export default function TS_Union_Types() {
  return (
    <div>
      <h1>TS Union Types</h1>
      <p>This is the TS Union Types page.</p>
    </div>
  );
}